import {Segmented,ConfigProvider,theme} from "antd";

function Switcher({values,onChangeState}) {
    return (
        <ConfigProvider
            theme={{
                algorithm: theme.darkAlgorithm,
                token: {
                    colorText:"white",
                    colorBgBase: '#293069',
                },

            }}>

            <Segmented
                options={values}
                onChange={(value) => {
                    onChangeState(value)
                }}
            />
        </ConfigProvider>

    )

}
export default Switcher